import React from "react";

import { GetStaticProps } from "next";
import {
  ATypeBeneficiaryHead,
  BTypeCardView,
  CTypeBreadCrumb,
  GOI_WEB_URL,
} from "goi_common";
import crematorium from "goi_common/src/constants/hwajang_detail.json";
import facilities from "goi_common/src/constants/facilities_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticProps: GetStaticProps = async () => {
  const regionCrematoriums = crematorium.filter((p) =>
    targetSidos.includes(String(p.sido))
  );
  const regionPublicFacilities = facilities.filter(
    (f) => targetSidos.includes(f.sido) && f.is_public
  );
  const description =
    "강원장례정보공개 (고이장례연구소) - 기초생활수급자는 어떻게 장례 준비해야 할까요? 2가지 혜택 확인";

  return {
    props: {
      regionCrematoriums,
      regionPublicFacilities,
      pageDescription: description,
      pageKeywords: `기초생활수급자 장례, 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마`,
      pageOgTitle: `강원 기초생활수급자 장례혜택 정보 :: 강원장례정보공개 (고이장례연구소)`,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

export default function index({
  regionCrematoriums,
  regionPublicFacilities,
  pageOgTitle,
}: {
  regionCrematoriums: Array<any>;
  regionPublicFacilities: Array<any>;
  pageOgTitle: string;
}) {
  const carouselItems = regionCrematoriums.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.gangwon-portal.co.kr/benefit-support/free-crema/${res.companyname} 기초생활수급자 안내`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionCrematoriums.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionCrematoriums.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <CTypeBreadCrumb
        firstItem={{
          text: `기초수급자장례 추천`,
          href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
          event: {
            domain: "gangwon",
            path: "benef",
            trigger_and_target: "br_crumb_mth_req",
          },
        }}
        secondItem={{
          text: `기초생활수급자 장례헬프센터`,
          href: `/gangwon-benefit/`,
          event: {
            domain: "gangwon",
            path: "benef",
            trigger_and_target: "br_crumb_benef",
          },
        }}
        goiHomeEvent={{
          domain: "gangwon",
          path: "benef",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />
      <Stack
        gap="6px"
        padding="40px 20px 20px"
        margin="10px 12px 20px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <ATypeBeneficiaryHead
          titleSido="강원"
          mainColor={regionColor}
          event={{
            domain: "gangwon",
            path: "benef",
            trigger_and_target: "goi_call",
          }}
        />
      </Stack>

      <Stack
        gap="6px"
        padding="40px 20px 20px"
        margin="20px 12px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <h4 className="subtitle_18_b">강원 기초생활수급자 무료 화장장</h4>
        {regionCrematoriums.map((res) => (
          <BTypeCardView
            descriptions={["기초생활수급자 무료"]}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/gangwon-benefit/crema/${res.companyname}/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "gangwon",
              path: "benef",
              trigger_and_target: "uv_fr_crema_detail",
            }}
          />
        ))}
      </Stack>

      <Stack
        gap="6px"
        padding="40px 20px 20px"
        margin="20px 12px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <h4 className="subtitle_18_b">강원 기초생활수급자 무료 장지 (공설)</h4>
        {regionPublicFacilities.map((res) => (
          <BTypeCardView
            descriptions={[""]}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/gangwon-benefit/facility/${res.companyname}/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "gangwon",
              path: "benef",
              trigger_and_target: "uv_fr_facility_detail",
            }}
          />
        ))}
      </Stack>
    </>
  );
}
